import React from 'react'
import PropTypes from 'prop-types'

import { Placeholder } from './TextPlaceholder.styles'

/**
 *
 */
// @ts-expect-error TS(7031) FIXME: Binding element 'width' implicitly has an 'any' ty... Remove this comment to see the full error message
const TextPlaceholder = ({ width, height }) => (
  // @ts-expect-error TS(2769) FIXME: No overload matches this call.
  <Placeholder width={width} height={height} data-testid="placeholder" />
)

TextPlaceholder.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
}

TextPlaceholder.defaultProps = {
  width: '100%',
  height: '100%',
}

export default TextPlaceholder
